export default __webpack_public_path__ + "static/media/dot-igaming-solid-white.f299ca6d.svg";